module.exports = __webpack_public_path__ + "static/media/professional.7a6a078b.svg";